import React from 'react';
import Header from './../../components/header';
import AboutBody from './body';
import Footer from '../../components/footer';

function About(props) {
    document.title = `About Yebokenny`;
    return (
        <div>
            <Header></Header>
            <AboutBody></AboutBody>
            <Footer></Footer>
        </div>
    );
}

export default About;